import { render, staticRenderFns } from "./InscripcionrestTwo.vue?vue&type=template&id=a28169c0"
import script from "./InscripcionrestTwo.vue?vue&type=script&lang=js"
export * from "./InscripcionrestTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports